<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Settings</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <b-field label="Site Name">
        <b-input v-model.trim="form.name" type="text" placeholder="Enter Site Name" required></b-input>
      </b-field>

      <b-field label="Player screen">
        <div class="tb-checkbox-grid">
          <b-checkbox v-model="form.show_agent">Show Agent List</b-checkbox>
          <b-checkbox v-model="form.show_paginate">Show Pagination</b-checkbox>
        </div>
      </b-field>

      <b-field label="WhatsApp Link">
        <b-input v-model.trim="form.whatsapp" type="text" placeholder="ex. https://wa.me/+917575757575"></b-input>
      </b-field>

      <b-field label="Payment Link">
        <b-input v-model.trim="form.payment" type="text" placeholder="ex. razorpay/paytm/upi links"></b-input>
      </b-field>

      <b-field label="Alert" message="Shown to players a few seconds after the home screen loads.">
        <b-input v-model="form.alert" type="textarea"></b-input>
      </b-field>

      <div class="colors">
        <b-field label="Primary Color">
          <b-input v-model="form.p_color" type="color" required></b-input>
        </b-field>
        <b-field label="Background Color">
          <b-input v-model="form.bg_color" type="color" required></b-input>
        </b-field>
        <b-field label="Header Color">
          <b-input v-model="form.logo_color" type="color" required></b-input>
        </b-field>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button type="button" class="button is-primary" @click="submit()">Change Settings</button>
    </footer>
  </div>
</template>

<script>
  const DEFAULTS = {
    name: "",
    alert: "",
    whatsapp: "",
    payment: "",
    show_agent: true,
    show_paginate: true,
    p_color: "#001b7c",
    bg_color: "#3f3f3f",
    logo_color: "#181818"
  };

  export default {
    name: "Settings",
    data() {
      return {
        form: { ...DEFAULTS }
      };
    },
    methods: {
      // Picks only the known keys out of the stored info blob so an unexpected
      // field can never be echoed back on save.
      setup(info) {
        const form = { ...DEFAULTS };
        Object.keys(DEFAULTS).forEach((key) => {
          const value = info[key];
          if (value !== undefined && value !== null) form[key] = value;
        });
        this.form = form;
      },
      submit() {
        if (!this.form.name) {
          return this.$buefy.toast.open({ message: "Site Name can't be empty", type: "is-danger" });
        }
        this.$emit("ChangeSettings", { ...this.form });
        this.$parent.close();
      }
    },
    mounted() {
      this.setup(this.$store.state.info);
    }
  };
</script>

<style scoped>
  .colors {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 0 14px;
  }
</style>
